/* eFolio · Agenda 2027 — movimiento de las secciones efl-agenda */
(() => {
  // Cada sección carga este archivo: solo se ejecuta la primera vez
  if (window.efaIniciada) return;
  window.efaIniciada = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const editor = !!(window.Shopify && Shopify.designMode);

  // Aparecer al bajar: cada bloque entra con un pequeño retraso respecto al anterior
  const grupos = ['.efa-head', '.efa-pains>*', '.efa-pains-close', '.efa-steps>*', '.efa-disclaimer', '.efa-kit>.efa-item',
    '.efa-month h3', '.efa-month li', '.efa-month-foot', '.efa-formats>*', '.efa-spain', '.efa-car figure', '.efa-car-hint',
    '.efa-cta-again', '.efa-reviews>*', '.efa-buy>*'];
  let io = null;
  function revelar(raiz) {
    const els = [];
    grupos.forEach((sel) => raiz.querySelectorAll(sel).forEach((el) => {
      if (el.classList.contains('efa-rv')) return;
      const i = [...el.parentNode.children].filter((x) => x.matches(sel)).indexOf(el);
      el.classList.add('efa-rv');
      el.style.setProperty('--d', Math.min(i, 6) * 0.08 + 's');
      els.push(el);
    }));
    raiz.querySelectorAll('.efa-item img').forEach((el) => { el.classList.add('efa-rv-img'); els.push(el); });
    if (reduce || editor || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('efa-in')); return; }
    io = io || new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('efa-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach((el) => io.observe(el));
  }

  // Galería: cambiar la imagen grande con un fundido
  function galeria(raiz) {
    const main = raiz.querySelector('.efa-gal-main img');
    if (!main) return;
    raiz.querySelectorAll('.efa-thumbs button').forEach((b) => b.addEventListener('click', () => {
      raiz.querySelectorAll('.efa-thumbs button').forEach((x) => x.setAttribute('aria-current', x === b));
      main.classList.add('efa-cambia');
      setTimeout(() => {
        main.removeAttribute('srcset');
        main.src = b.dataset.src;
        main.alt = b.dataset.alt || '';
        const fin = () => main.classList.remove('efa-cambia');
        main.onload = fin; setTimeout(fin, 400);
      }, 200);
    }));
  }

  // Mira por dentro: ampliar páginas y avance automático hasta que la clienta toque el carrusel
  function carrusel(raiz) {
    const car = raiz.querySelector('.efa-car');
    const dlg = raiz.querySelector('.efa-zoom');
    if (dlg) {
      const big = dlg.querySelector('img');
      raiz.querySelectorAll('.efa-car button').forEach((b) => b.addEventListener('click', () => {
        big.src = b.dataset.big; big.alt = b.querySelector('img').alt;
        if (dlg.showModal) dlg.showModal();
      }));
      dlg.addEventListener('click', (e) => { if (e.target !== big) dlg.close(); });
    }
    if (!car || reduce || editor) return;
    let parado = false, visible = false;
    ['pointerdown', 'wheel', 'touchstart'].forEach((ev) => car.addEventListener(ev, () => { parado = true; }, { passive: true }));
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; }, { threshold: 0.5 }).observe(car);
    setInterval(() => {
      if (parado || !visible || document.hidden) return;
      const f = car.querySelector('figure'); if (!f) return;
      if (car.scrollLeft + car.clientWidth >= car.scrollWidth - 4) car.scrollTo({ left: 0, behavior: 'smooth' });
      else car.scrollBy({ left: f.offsetWidth + 14, behavior: 'smooth' });
    }, 2800);
  }

  // Barra fija en móvil: aparece cuando el botón principal sale de la pantalla
  function barra(raiz) {
    const st = raiz.querySelector('.efa-sticky'), cta = raiz.querySelector('.efa-buy .efa-btn');
    if (!st || !cta || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      st.classList.toggle('efa-on', on); st.setAttribute('aria-hidden', !on);
    }).observe(cta);
  }

  function iniciar(raiz) { revelar(raiz); galeria(raiz); carrusel(raiz); barra(raiz); }
  document.querySelectorAll('.efa').forEach(iniciar);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.efa').forEach(iniciar));
})();
